import classNames from 'classnames';
import styles from './PosterContainer.module.css';

//#region [Component]
type PosterContainerProps = React.ComponentPropsWithoutRef<'section'>;

export default function PosterContainer({ className, children, ...rest }: PosterContainerProps) {
    return (
        <section className={classNames(styles.SPosterContainer, className)} {...rest}>
            {children}
        </section>
    );
}
//#endregion
